import React from "react";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ModalMessage,
  ButtonGroup,
  Row,
  RateButton,
} from "./RateCollectionModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";

import { ReactComponent as ThumbUpIcon } from "../../assets/icons/thumbs-up.svg";
import { ReactComponent as ThumbUpSelectedIcon } from "../../assets/icons/thumbs-up-selected.svg";
import { ReactComponent as ThumbDownIcon } from "../../assets/icons/thumbs-down.svg";
import { ReactComponent as ThumbDownSelectedIcon } from "../../assets/icons/thumbs-down-selected.svg";

const RateCollectionModal = ({ isOpen, onClose, onConfirm, rating }) => {
  useLockBodyScroll(isOpen);

  const handleConfirm = (rating) => {
    onConfirm(rating);
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Report Results</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>
          <ModalMessage>
            How would you rate the results of this generation?
          </ModalMessage>

          <ButtonGroup>
            <RateButton
              $ratingUp={rating === 1}
              onClick={() => {
                handleConfirm(1);
              }}
            >
              {rating === 1 ? <ThumbUpSelectedIcon /> : <ThumbUpIcon />}
              Good
            </RateButton>

            <RateButton
              $ratingDown={rating === -1}
              onClick={() => {
                handleConfirm(-1);
              }}
            >
              {rating === -1 ? <ThumbDownSelectedIcon /> : <ThumbDownIcon />}
              <span style={{ paddingInline: "5px" }}>Bad</span>
            </RateButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default RateCollectionModal;
